import { render, staticRenderFns } from "./GenericLimits.vue?vue&type=template&id=59807410&scoped=true"
import script from "./GenericLimits.vue?vue&type=script&lang=js"
export * from "./GenericLimits.vue?vue&type=script&lang=js"
import style0 from "./GenericLimits.vue?vue&type=style&index=0&id=59807410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59807410",
  null
  
)

export default component.exports